import { render, staticRenderFns } from "./FinalRulesDashboard.vue?vue&type=template&id=528d22ee&"
import script from "./FinalRulesDashboard.vue?vue&type=script&lang=js&"
export * from "./FinalRulesDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports